export const STATE_NAME = 'booking';
